import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  ChannelLogo,
  FlexBox,
  IconButton,
  IconFontAwesome,
  Panel,
  StandByOverlay
} from '@directsoftware/ui-kit-web-admin';
import * as brandAction from '../../redux/action/brand';
import SliceMachine from '../shared/slice-machine';
import { useDetectMobile } from '../../../shared/hooks/useDetectMobile';
import Meta from './meta';

const HomeV2 = props => {
  const dispatch = useDispatch();
  const { isMobile } = useDetectMobile();
  const brand = useSelector(state => state.brand);
  const [pageLoading, setPageLoading] = useState(true);
  const [showBanner, setShowBanner] = useState(false);
  const setBrand = () => {
    axios.get('/api/organizations/home').then(async response => {
      await dispatch(brandAction.setHome(response.data));
      setPageLoading(false);
      if (typeof window.customJavascriptLoad === 'function') {
        window.customJavascriptLoad();
      }
    });
  };

  useEffect(() => {
    setBrand();
  }, []);

  useEffect(
    () => {
      if (
        brand &&
        (brand.id === 200000000575 ||
          brand.id === 200000000572 ||
          brand.id === 200000000576)
      ) {
        setTimeout(() => {
          setShowBanner(true);
        }, 5000);
      }
    },
    [brand]
  );

  if (pageLoading) return <StandByOverlay position="fixed" />;

  const slices = brand?.home?.slices || [];

  return slices.length > 0 ? (
    <>
      <Meta />
      {slices.map((slice, idx) => (
        <SliceMachine
          key={`slice-${idx}`}
          slice={slice}
          theme={brand.v2Theme}
        />
      ))}
      {showBanner && (
        <Panel
          addShadow
          className="demoBadge"
          paddingVertical={isMobile ? 's' : 'xs'}
        >
          <FlexBox
            gap="s"
            alignItems={isMobile ? 'flex-start' : 'center'}
            paddingHorizontal="s"
          >
            {!isMobile && (
              <Box>
                <ChannelLogo
                  channel="direct"
                  variation="full"
                  presetHeight="m"
                />
              </Box>
            )}
            <Box flex="1">
              {isMobile && (
                <Box paddingBottom="s">
                  <ChannelLogo
                    channel="direct"
                    variation="full"
                    presetHeight="m"
                  />
                </Box>
              )}
              {`${brand.name} is a demo site for `}
              <a
                href="https://directsoftware.com"
                target="_blank"
                style={{ color: brand.brand_info.colors?.color_primary }}
                rel="noreferrer"
              >
                Direct
              </a>
              {
                ' that you can interact with. It’s not a real rental site, but you can '
              }
              <a
                href="https://directsoftware.com/products/direct-booking-websites"
                target="_blank"
                style={{ color: brand.brand_info.colors?.color_primary }}
                rel="noreferrer"
              >
                easily create one like it
              </a>
              {` for your company.`}
            </Box>
            <IconButton
              onClick={() => {
                setShowBanner(false);
              }}
              size="dense"
              variation="secondary"
              appearance="ghost"
            >
              <IconFontAwesome name="times" />
            </IconButton>
          </FlexBox>
        </Panel>
      )}
    </>
  ) : (
    <>
      <Meta />
      <Box padding="xl" style={{ textAlign: 'center', minHeight: '40vh' }}>
        <p>
          Welcome to {brand.name}.{' '}
          <a href="/listings/search">Browse listings</a> to get started.
        </p>
      </Box>
    </>
  );
};

HomeV2.propTypes = {};

export default HomeV2;
